import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import { client } from "../../sanity/client";

const Releases = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  //Four products visible as default.
  const [visibleProducts, setVisibleProducts] = useState(18);

  // Runs when "Show more products"-button is clicked.
  const displayMoreProducts = () => {
    setVisibleProducts((products) => products + 12);
  };

  // *** SANITY CMS FETCH RELEASES ***
  const [releases, setReleases] = useState([]);

  useEffect(() => {
    const fetchReleases = async () => {
      try {
        const links = await client.fetch(
          `*[_type == "releases"] | order(order asc) {title, imageUrl, linkUrl}`
        );
        setReleases(links);
      } catch (error) {
        console.error("Error fetching releases:", error);
      }
    };

    fetchReleases();
  }, []);
  // *** SANITY CMS FETCH RELEASES END ***

  return (
    <div className="flex flex-col justify-center items-center min-h-screen">
      <div className="mb-10">
        {/*  <div className=" mt-5">
             <div className="flex md:flex-row justify-center">
            <img
              src={Logo}
              className="w-[350px]"
              data-aos="flip-left"
              data-aos-duration="2000"
            />
           
            <h1 className="text-7xl mr-10" data-aos="flip-up">
              Releases.
            </h1>
            
          </div>
        </div>*/}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-1 container flex flex-col justify-center items-center md:my-5 px-2 md:px-5">
          {releases.slice(0, visibleProducts).map((release, index) => (
            <a
              key={index}
              href={release.linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-center shadow-lg"
              data-aos="fade-in"
            >
              <img
                src={release.imageUrl}
                alt={"" /* `Image ${index + 1}`*/}
                className="max-w-full transition-opacity duration-300 hover:opacity-70"
                loading="lazy"
                width="600"
                height="600"
              />
            </a>
          ))}
        </div>

        <div className="flex justify-end mr-5">
          {visibleProducts < releases.length && (
            <button
              className="bg-white hover:bg-gray-100 px-4 py-2 border-2 border-solid border-black mb-5 my-1 w-48"
              onClick={displayMoreProducts}
            >
              <h1 className="text-xl">Show more releases ...</h1>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Releases;
